export const areCookiesEnabled = () =>
  document.cookie.indexOf("cookieconsent_status=allow") > -1 ? true : false;
